/**
 * Converts seconds since midnight to a formatted time string
 * @param seconds Number of seconds since midnight
 * @param format Format to use (12h or 24h)
 * @returns Formatted time string (e.g. "06:00 AM" or "18:00")
 */
export const formatTimeFromSeconds = (
  seconds: string | number,
  format: "12h" | "24h" = "12h"
): string => {
  const totalSeconds =
    typeof seconds === "string" ? parseInt(seconds, 10) : seconds;
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);

  if (format === "24h") {
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  } else {
    const period = hours >= 12 ? "PM" : "AM";
    const displayHours = hours % 12 || 12; // Convert 0 to 12 for 12 AM
    return `${displayHours}:${minutes.toString().padStart(2, "0")} ${period}`;
  }
};

/**
 * Converts time string in format HH:MM:SS to a formatted time string
 * @param timeString Time string in format HH:MM:SS
 * @param format Format to use (12h or 24h)
 * @returns Formatted time string (e.g. "06:00 AM" or "18:00")
 */
export const formatTimeString = (
  timeString: string,
  format: "12h" | "24h" = "12h"
): string => {
  if (!timeString) return "";

  const [hours, minutes] = timeString.split(":").map(Number);

  if (format === "24h") {
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  } else {
    const period = hours >= 12 ? "PM" : "AM";
    const displayHours = hours % 12 || 12; // Convert 0 to 12 for 12 AM
    return `${displayHours}:${minutes.toString().padStart(2, "0")} ${period}`;
  }
};
